import * as Sentry from '@sentry/react'
import type { PropsWithChildren } from 'react'
import { ToastProvider } from '@/components/ui/ToastProvider'

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <main className="grid min-h-screen place-items-center bg-canvas p-6 text-primary">
          <section className="w-full max-w-lg rounded-2xl border border-status-failed/20 bg-raised p-8 shadow-2xl">
            <p className="text-xs font-bold tracking-[0.16em] text-status-failed uppercase">
              Application error
            </p>
            <h1 className="mt-3 text-2xl font-semibold text-primary">
              This page could not be displayed
            </h1>
            <p className="mt-3 text-sm leading-6 text-muted">
              {error instanceof Error
                ? error.message
                : 'An unexpected rendering error occurred.'}
            </p>
            <button
              className="mt-6 min-h-10 rounded-lg bg-accent-solid px-4 text-sm font-semibold text-on-solid hover:bg-accent-hover"
              type="button"
              onClick={resetError}
            >
              Try again
            </button>
          </section>
        </main>
      )}
    >
      <ToastProvider>{children}</ToastProvider>
    </Sentry.ErrorBoundary>
  )
}
